module.exports = {
  "country": "RS",
  "artist": "Željko Joksimović",
  "song": "Nije Ljubav Stvar",
  "year": "2012",
  "place": "3",
  "spotify": "0XPSz3tEODnQtWoPrhVwAr"
};